









































import { Component, Mixins, Prop } from "vue-property-decorator";
import { SessionStorageAccessor } from "../../../../../store/SessionStorageAccessor";
import { Directory } from "../../../../../domain/drawing";
import { IWizard, FormatReference } from "../../../../../domain/format";
import {
  NewDocumentEditorMixin,
} from "../../mixins";
import { DocumentEditor, FormatSelectView } from "../../../editor/wizard";
import LoadedDocumentPreprocessor from "../../LoadedDocumentPreprocessor.vue";
import { PatientFindView } from "../../../../patient/selectors/wizard/guest";

@Component({
  components: {
    DocumentEditor,
    LoadedDocumentPreprocessor,
    PatientFindView,
    FormatSelectView,
  },
})
export default class NewDocumentEditor extends Mixins(NewDocumentEditorMixin) {
  @Prop()
  isRegistered: boolean;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop()
  authenticate: (isForcibly: boolean) => Promise<boolean>;

  @Prop()
  wizard: IWizard;

  @Prop()
  loadWizardTemplates: (key: string) => Promise<Directory<string, FormatReference>[]>;

  get registeredOperations(): { label: string, process: (unlock: () => Promise<boolean>) => void }[] {
    const entryParameters = SessionStorageAccessor.entryQueryParameters;
    return [
      // 同一患者で文書を作成するのはフォーマット未指定で起動された時だけにする.(同一患者で同一の文書を作成するユースケースは想定できない.)
      !entryParameters.formatId
        ? {
          label: "同一患者で文書を作成",
          process: async (unlock: () => Promise<boolean>) => {
            // 登録時認証されてるか管理権限認証できないと実行しない。(このボタンが表示されるのは登録後なので登録時に認証されてるなら認証できる人が操作してると判断。)
            if (this.wizard.registration.shouldAuthenticate || await unlock()) {
              this.editNewDocument(false, true);
            }
          },
        }
        : null,
      // 患者を選択して文書作成する時は、フォーマット指定有無でフォーマット選択するかどうかを切り替える.(明示的にフォーマットID指定されてる場合は選択させない.)
      !entryParameters.patientNo
        ? {
          label: "患者を選択して文書を作成",
          process: async (unlock: () => Promise<boolean>) => {
            // 登録時認証されてるか管理権限認証できないと実行しない。(このボタンが表示されるのは登録後なので登録時に認証されてるなら認証できる人が操作してると判断。)
            if (this.wizard.registration.shouldAuthenticate || await unlock()) {
              this.editNewDocument(true, !entryParameters.formatId);
            }
          },
        }
        : null,
    ].filter(o => !!o);
  }

  editNewDocument(shouldReselectPatient: boolean, shouldReselectFormat: boolean): void {
    this.$redirect("/Wizard/Guest/EditNewDocument", {
      patientNo: shouldReselectPatient ? undefined : this.patient.id,
      formatId: shouldReselectFormat ? undefined : this.format.id,
      // defaultFormatIdは引き継がない.
      folderId: this.folderId,
      rootFolderId: this.rootFolderId,
      // リンク情報は引き継がない.(1文書しかリンクできないので.)
      institutionNo: this.institutionNo,
      regionalInstitutionNo: this.regionalInstitutionNo,
      hisInfoGetterParameter: this.hisInfoGetterParameter,
    });
  }
}
